import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import ThemeProviderContainer from './ThemeProviderContainer';
import VersionRouter from './VersionRouter';

export function routes({ store, history } = {}) {
  return (
    <Provider {...{ store }}>
      <IntlProvider locale="en">
        <ThemeProviderContainer>
          <VersionRouter {...{ history }} />
        </ThemeProviderContainer>
      </IntlProvider>
    </Provider>
  );
}

routes.displayName = 'routes';



// WEBPACK FOOTER //
// ./js/routes/index.js